import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import CustomButton from "shared/components/common/customButton";
import { setQuestionnaireReducer } from "shared/redux/reducers/questionnaire";
import { useDispatch } from "react-redux";

interface Props {
  handleSubmit?: any;
  show: boolean | any;
  handleClose: any;
}

const LeaveAlert = ({ show, handleClose, handleSubmit }: Props) => {
  const dispatch = useDispatch();
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames("flex items-center justify-end px-4 mt-4 mb-3")}
        >
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              handleClose();
            }}
          >
            <Icons.Cross />
          </div>
        </div>
        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-4")}
        >
          <div className={classNames("flex flex-col gap-2 mb-4")}>
            <h6>Are you sure you want to leave?</h6>
            <p>You have unsaved changes.</p>
          </div>
          <div
            className={classNames(
              "flex items-center w-full justify-between gap-4"
            )}
          >
            <CustomButton
              title={"No"}
              containerStyle={styles.defaultButton}
              onClick={handleClose}
              style={{ width: "100%" }}
            />
            <CustomButton
              title={"Yes"}
              containerStyle={styles.actionButton}
              onClick={() => {
                dispatch(
                  setQuestionnaireReducer({ formData: [], lastStep: 1 })
                );
                handleSubmit();
              }}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default LeaveAlert;
